import { NBSP } from '../../../constants/symbols';

export enum EPhoneVerificationStep {
  PHONE,
  VERIFY,
}

export const PHONE_STEP_TITLE = {
  [EPhoneVerificationStep.PHONE]: `По${NBSP}какому номеру перезвонить?`,
  [EPhoneVerificationStep.VERIFY]: `Введите код из${NBSP}смс`,
};
